export enum RideType {
  NORMAL = "NORMAL",
  SHARED = "SHARED",
  DELIVERY = "DELIVERY",
}

export enum RideStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  STARTED = "STARTED",
  ARRIVED = "ARRIVED",
  ENDED = "ENDED",
  CANCELED = "CANCELED",
  CANCELED_WITH_PAYMENT = "CANCELED_WITH_PAYMENT",
  PAYMENT_SUCCEED = "PAYMENT_SUCCEED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
}

export enum SharedRideType {
  RIDE = "RIDE",
  DELIVERY = "DELIVERY",
  HYBRID = "HYBRID",
}

export enum SharedRideStatus {
  ONGOING = "ONGOING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum RouteStopType {
  PICKUP = "PICKUP",
  DROP = "DROP",
}

export enum RouteStopStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}

export enum PaymentMode {
  CASH = "CASH",
  CARD = "CARD",
  WALLET = "WALLET",
}

export enum CancelledByType {
  RIDER = "RIDER",
  DRIVER = "DRIVER",
  SYSTEM = "SYSTEM",
}

export enum CarType {
  ECONOMY = "ECONOMY",
  COMFORT = "COMFORT",
  PREMIUM = "PREMIUM",
  VAN = "VAN",
}

export interface Location {
  latitude: number;
  longitude: number;
  place: string;
  country_code?: string;
  region_code?: string;
  city?: string;
}

export interface Driver {
  driver_id: string;
  driver_name: string;
  driver_picture?: string;
  driver_rating?: number;
  driver_phone_number: string;
  driver_email?: string;
}

export interface Customer {
  id: string;
  name: string;
  phone: string;
  email: string;
  profile_picture?: string;
  rating?: number;
}

export interface Car {
  car_id: string;
  car_registration_number: string;
  model: string;
  make: string;
  car_type?: CarType;
}

export interface Discount {
  id: string;
  code: string;
  amount: number;
  type: "PERCENTAGE" | "FIXED";
  is_active: boolean;
}

export interface PackageDetails {
  package_type: string;
  package_size: string;
  package_description?: string;
  weight: number;
  length: number;
  width: number;
  height: number;
}

export interface PackageRecipient {
  full_name: string;
  contact_number: string;
  house_no?: string;
  building?: string;
  street?: string;
  area?: string;
  city?: string;
  zip_code?: string;
  landmark?: string;
  instructions?: string;
}

export interface RouteStop {
  child_ride_id: string;
  type: RouteStopType;
  latitude: number;
  longitude: number;
  rider_name: string;
  status: RouteStopStatus;
  location: Location;
  sequence: number;
  arrival_time?: string;
  departure_time?: string;
}

export interface Ride {
  _id: string;
  rider_id: string;
  rider_name: string;
  rider_rating?: number;
  rider_phone_number?: string;
  rider_email?: string;
  driver?: Driver;
  car?: Car;
  fare_amount: number;
  with_toll?: boolean;
  discount?: Discount;
  discount_amount?: number;
  payment_method_id?: string;
  customer_id?: string;
  eta: string;
  car_type?: CarType;
  pickup_location: Location;
  destination_location: Location;
  future_ride?: boolean;
  scheduled_time?: string;
  start_time?: string;
  end_time?: string;
  driver_arrived_time?: string;
  ride_status: RideStatus;
  cancelled_by?: CancelledByType;
  surge_multiplier?: number;
  country_code: string;
  region_code: string;
  payment_intent_id?: string;
  transfer_id?: string;
  payment_failure_reason?: string;
  cancellation_reason?: string;
  driver_ride_percentage?: number;
  shared_ride_id?: string;
  ride_type: RideType;
  payment_mode?: PaymentMode;
  driver_payable_amount?: number;
  teracar_commission?: number;
  partner_id?: string;
  partner_commission?: number;
  premium_fee?: number;
  ended_by?: string;
  package_details?: PackageDetails[];
  package_recipient?: PackageRecipient;
  is_helper_needed?: boolean;
  created_at: string;
  updated_at: string;
}

export interface SharedRide {
  id: string;
  driver?: Driver;
  car?: Car;
  car_type?: CarType;
  first_pickup_location?: Location;
  last_destination_location?: Location;
  start_time?: string;
  end_time?: string;
  ride_status: SharedRideStatus;
  shared_ride_type?: SharedRideType;
  cancelled_by?: CancelledByType;
  child_rides_id: string[];
  routes_stops: RouteStop[];
  country_code: string;
  region_code: string;
  created_at: string;
  updated_at: string;
}

export interface SharedRideWithChildRides extends SharedRide {
  child_rides: Ride[];
}
